import axios from "axios";
import { errorHandler } from '../utils';
import { isEmpty } from "lodash";
import { apiURL, getAccessToken } from '../helpers';

export const goodsDispatchOrderClose = async (data) => {
  const url = apiURL('/goods/dispatched/order/close');
  const accessToken = getAccessToken();

  try {
    const response = await axios({
      method: "POST",
      url: url,
      data,
      headers: { Authorization: `Bearer ${accessToken}` }
    });
    return response.data;
  }
  catch (err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      // const callback = async () => await goodsDispatchOrderClose(data)
      // const { value, code, message, stack } = await errorHandler.response(error, callback());
      // return { error: { value, code, message, stack } };
    }
    else {
      console.log(err.message)
      return { error: { message: err.message } };
    }
  }
}
